import { useRouter } from "next/router";
import { getDomainUrl } from "@/utils/getDomainUrl";
import { addQueryParamToUrl } from "@/utils/addQueryParamToUrl";

export const useReferrerUrl = () => {
  const router = useRouter();

  function getReferrerUrlWithParams(params: QueryParam[]): string {
    let referrerUrl = getDomainUrl(router.asPath);

    params.forEach((param) => {
      referrerUrl = addQueryParamToUrl(referrerUrl, param.key, param.value);
    });

    return referrerUrl;
  }

  return {
    getReferrerUrlWithParams,
  };
};
